import LayoutHome from '@/components/layouts/LayoutHome.vue'
import { offers } from '@/services/offers'
import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/home',
    component: LayoutHome,
    children: [
      {
        name: '',
        path: '',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/IndexView.vue')
      },

      {
        name: 'institutional-pages',
        path: '/pages',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/PagesView.vue')
      },
      {
        name: 'coupons',
        path: '/coupons',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/CouponsView.vue')
      },
      {
        name: 'sacUsers',
        path: '/sac',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/SacUsersView.vue')
      },
      {
        name: 'users',
        path: '/users',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/UserManagement.vue')
      },
      {
        name: 'saller-users',
        path: '/saller-users',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/SallerUsersView.vue')
      },
      {
        name: 'request-payments',
        path: '/request-payments',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/requestPayment/RequestPaymentsView.vue')
      },
      {
        name: 'request-payment-details',
        path: '/request-payment-details',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/requestPayment/RequestPaymentDetailsView.vue')
      },
      {
        name: 'companies',
        path: '/companies',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/EmpresarialsPlansManagement.vue')
      },
      {
        name: 'editCompany',
        path: '/edit-company',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/EditCompany.vue')
      },
      {
        name: 'partners',
        path: '/partners',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/PartnersView.vue')
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/FaqView.vue')
      },
      {
        name: 'plans',
        path: '/plans',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/PlansView.vue')
      },
      {
        name: 'banners',
        path: '/banners',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/BannersView.vue')
      },
      {
        name: 'company-user',
        path: '/business-registration',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/CompanyUserView.vue')
      },
      {
        name: 'individual-user',
        path: '/individual-registration',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/IndividualUserView.vue')
      },
      {
        name: 'messages',
        path: '/messages',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/MessagesView.vue')
      },
      {
        name: 'push-notifications',
        path: '/push-notifications',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/PushNotificationsView.vue')
      },
      {
        name: 'motivational-phrases',
        path: '/motivational-phrases',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/MotivationalPhrasesView.vue')
      },
      {
        name: 'testimonials',
        path: '/testimonials',
        component: () => import(/* webpackChunkName: "about" */ '../views/client/TestimonialsView.vue')
      },

    ]
  }
]

const router = createRouter({
  history: createWebHistory (),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    return next();
  }
  try {
    await offers.getCurrentUser();
    next();
  } catch (e) {
    next('/');
  }
});

export default router
